import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=1b5d91ee&scoped=true"
import script from "./TextField.vue?vue&type=script&lang=js"
export * from "./TextField.vue?vue&type=script&lang=js"
import style0 from "./TextField.vue?vue&type=style&index=0&id=1b5d91ee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d91ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5d91ee')) {
      api.createRecord('1b5d91ee', component.options)
    } else {
      api.reload('1b5d91ee', component.options)
    }
    module.hot.accept("./TextField.vue?vue&type=template&id=1b5d91ee&scoped=true", function () {
      api.rerender('1b5d91ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/personalization/fields/TextField.vue"
export default component.exports